export default __webpack_public_path__ + "static/media/image-intro-desktop.2f3429f6.jpg";